import { COMMON_SAVE } from './commonAction';

const init = {};

export default (state = {}, action) => {
  const newState = { ...state };
  switch (action.type) {
    case COMMON_SAVE:
      newState[action.key] = { ...init, data: action.payload, meta: action?.meta };
      break;
    default:
  }
  return newState;
};
